import { render, staticRenderFns } from "./ContainerBlue.vue?vue&type=template&id=028f664f&"
import script from "./ContainerBlue.vue?vue&type=script&lang=js&"
export * from "./ContainerBlue.vue?vue&type=script&lang=js&"
import style0 from "./ContainerBlue.vue?vue&type=style&index=0&id=028f664f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports